import React, { Component } from 'react';

/**
 * Kutilmagan xatoda oq/qora ekran o'rniga tushunarli xabar.
 *
 * Qaysi sahifada yuz bergani ham yoziladi — «e.map is not a function» degan
 * yolg'iz satrdan sababni topib bo'lmaydi.
 *
 * `resetKey` o'zgarganda (odatda manzil) xato tozalanadi: bitta sahifadagi
 * nosozlik butun ilovani qulflab qo'ymasligi kerak, boshqa bo'limga o'tsa
 * dastur o'zi tiklanadi.
 */
export class ErrorBoundary extends Component<
  { children: React.ReactNode; full?: boolean; resetKey?: string },
  { error: Error | null; stack: string; path: string }
> {
  state = { error: null as Error | null, stack: '', path: '' };

  static getDerivedStateFromError(error: Error) {
    return { error, path: location.pathname + location.search };
  }

  componentDidUpdate(prev: { resetKey?: string }) {
    if (this.state.error && prev.resetKey !== this.props.resetKey) {
      this.setState({ error: null, stack: '', path: '' });
    }
  }

  componentDidCatch(error: Error, info: any) {
    this.setState({ stack: String(info?.componentStack || '').split('\n').slice(0, 6).join('\n') });
    // eslint-disable-next-line no-console
    console.error('[Alight] sahifa xatosi:', location.pathname, error);
  }

  private copy = () => {
    const t = [this.state.path, this.state.error?.message, this.state.error?.stack, this.state.stack]
      .filter(Boolean).join('\n');
    navigator.clipboard?.writeText(t);
  };

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ minHeight: this.props.full ? '100vh' : 320, display: 'grid', placeItems: 'center', padding: 20 }}>
        <div className="card" style={{ maxWidth: 520, textAlign: 'center' }}>
          <h3 style={{ marginTop: 0 }}>Xatolik yuz berdi</h3>
          <p className="muted" style={{ fontSize: 12.5, wordBreak: 'break-word', marginBottom: 6 }}>
            {String(this.state.error?.message || this.state.error)}
          </p>
          <p className="muted" style={{ fontSize: 11.5, marginTop: 0 }}>
            Sahifa: <span className="code">{this.state.path || location.pathname}</span>
          </p>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button className="btn btn-primary" onClick={() => location.reload()}>Qayta yuklash</button>
            <button className="btn" onClick={() => { location.href = '/'; }}>Bosh sahifa</button>
            <button className="btn btn-sm" onClick={this.copy}>Xato matnini nusxalash</button>
          </div>
        </div>
      </div>
    );
  }
}
